const LabelHelper = {
	availability(status) {
		switch (status) {
			case 'available':
				return 'Available';
			case 'unavailable':
				return 'Unavailable';
			case 'occupied':
				return 'Occupied';
			case 'under_maintenance':
				return 'Under Maintenance';
			default:
		}
		return '';
	},
	bookingType(type) {
		// TODO: BOOKING TYPES
		switch (type) {
			case 'online_booking_equipment':
				return 'Online Booking Equipment';
			case 'non_booking_equipment':
				return 'Non-Booking Equipment';
			default:
		}
		return '';
	},
	equipmentStatus(status) {
		switch (status) {
			case 'enabled':
				return 'Enabled';
			case 'disabled':
				return 'Disabled';
			default:
		}
		return '';
	},
	equipmentController(controller) {
		// TODO: Types of Controllers
		switch (controller) {
			case JSON.stringify({ power_on: 'CCDDA10100010001A448', power_off: 'CCDDA10100000001A346'}):
				return '1';
			case JSON.stringify({ power_on: 'CCDDA10100020002A64C', power_off: 'CCDDA10100000002A448'}):
				return '2';
			case JSON.stringify({ power_on: 'CCDDA10100040004AA54', power_off: 'CCDDA10100000004A64C'}):
				return '3';
			case JSON.stringify({ power_on: 'CCDDA10100080008B264', power_off: 'CCDDA10100000008AA54'}):
				return '4';
			case JSON.stringify({ power_on: 'CCDDA10100100010C284', power_off: 'CCDDA10100000010B264'}):
				return '5';
			case JSON.stringify({ power_on: 'CCDDA10100200020E2C4', power_off: 'CCDDA10100000020C284'}):
				return '6';
			case JSON.stringify({ power_on: 'CCDDA101004000402244', power_off: 'CCDDA10100000040E2C4'}):
				return '7';
			case JSON.stringify({ power_on: 'CCDDA10100800080A244', power_off: 'CCDDA101000000802244'}):
				return '8';
			default:
		}
		return '';
	},
	adminStatus(status) {
		switch (status) {
			case 'enabled':
				return 'Enabled';
			case 'disabled':
				return 'Disabled';
			default:
		}
		return '';
	},
	location(status) {
		switch (status) {
			case 'available':
				return 'Available';
			case 'occupied':
				return 'Occupied';
			case 'under maintenance':
				return 'Under Maintenance';
			default:
		}
		return '';
	}
};

export default LabelHelper;
